export class TestingSet {
  constructor(name, endpoints) {
    this.name = name
    this.endpoints = endpoints
  }
}


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/testingSets/testingSet.js